import { MixpanelBasePayload } from '../mix-panel-context';

export interface PageSelectedPayload extends MixpanelBasePayload {
  pageName: string;
}

export function generatePageSelectedProperties(payload: PageSelectedPayload): PageSelectedPayload {
  return payload;
}
